module.exports = __webpack_public_path__ + "static/img/MH.78bf6cb4.svg";